/* Hibiscus storefront — ported from the demo's app.js and rewired to Shopify.
   Catalog/search/wishlist use window.HIBISCUS_PRODUCTS (generated by Liquid).
   Cart, variants and checkout use Shopify's real endpoints. */
(function () {
  var P = window.HIBISCUS_PRODUCTS || {};
  var CFG = window.HIBISCUS || { routes: {}, freeShip: 7000 };

  /* ---------- helpers ---------- */
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  var HEART = '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 21s-7-4.6-9.3-9C1 8.5 2.9 5 6.3 5c2 0 3.2 1.2 3.7 2 .5-.8 1.7-2 3.7-2 3.4 0 5.3 3.5 3.6 7-2.3 4.4-9 9-9 9Z"/></svg>';

  /* ---------- toast ---------- */
  var toast = document.getElementById('toast'), toastTimer;
  function showToast(msg) {
    if (!toast) return;
    toast.querySelector('.toast-msg').textContent = msg;
    toast.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove('show'); }, 2600);
  }

  /* ---------- card builder (search + wishlist) — mirrors product-card.liquid ---------- */
  function cardHTML(handle) {
    var p = P[handle]; if (!p) return '';
    var priceHtml = p.varies
      ? '<span class="from">From</span> <span class="now">' + p.priceMin + '</span>'
      : '<span class="now">' + p.priceMin + '</span>';
    var quick = p.solo
      ? '<button class="btn btn-soft btn-block" data-add-variant="' + p.vid + '">Quick add</button>'
      : '<a href="' + p.u + '" class="btn btn-soft btn-block">Choose options</a>';
    return '<article class="card" data-category="' + esc(p.c) + '" data-handle="' + esc(handle) + '" data-price="' + p.pmin + '">' +
      '<div class="card-media">' +
        '<button class="wish" data-wish-id="' + esc(handle) + '" aria-label="Save to wishlist">' + HEART + '</button>' +
        '<a href="' + p.u + '"><img loading="lazy" src="' + esc(p.img) + '" alt="' + esc(p.t) + '"></a>' +
        '<div class="quick">' + quick + '</div>' +
      '</div>' +
      '<div class="card-body"><span class="card-cat">' + esc(p.c) + '</span>' +
        '<h3><a href="' + p.u + '">' + esc(p.t) + '</a></h3>' +
        '<div class="price">' + priceHtml + '</div></div></article>';
  }

  /* ---------- Shopify cart ---------- */
  function addToCart(variantId, qty, thenCheckout) {
    if (!variantId) { showToast('Please choose your options first ✿'); return; }
    fetch(CFG.routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty || 1 }] })
    }).then(function (r) { return r.json(); }).then(function (data) {
      if (data && data.status && data.status !== 200) { showToast(data.description || 'Could not add to bag'); return; }
      updateCartCount();
      if (thenCheckout) { window.location.href = '/checkout'; return; }
      showToast('Added to your bag ✿');
    }).catch(function () { showToast('Could not add to bag'); });
  }
  function updateCartCount() {
    fetch(CFG.routes.cart + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); }).then(function (c) {
        document.querySelectorAll('.cart-count').forEach(function (el) {
          el.textContent = c.item_count; el.style.display = c.item_count > 0 ? 'grid' : 'none';
        });
      }).catch(function () {});
  }
  function changeLine(key, qty) {
    fetch(CFG.routes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function () { window.location.reload(); })
      .catch(function () { window.location.reload(); });
  }

  /* ---------- wishlist (localStorage, client-side) ---------- */
  var WKEY = 'hibiscus_wishlist';
  function getWish() { try { return JSON.parse(localStorage.getItem(WKEY)) || []; } catch (e) { return []; } }
  function saveWish(w) { localStorage.setItem(WKEY, JSON.stringify(w)); renderWishCount(); }
  function toggleWish(h) { var w = getWish(), i = w.indexOf(h); if (i >= 0) w.splice(i, 1); else w.push(h); saveWish(w); return w.indexOf(h) >= 0; }
  function renderWishCount() {
    var n = getWish().length;
    document.querySelectorAll('.wish-count').forEach(function (el) { el.textContent = n; el.style.display = n > 0 ? 'grid' : 'none'; });
  }
  function markWishHearts() {
    var w = getWish();
    document.querySelectorAll('.wish[data-wish-id]').forEach(function (b) {
      var on = w.indexOf(b.getAttribute('data-wish-id')) >= 0;
      b.classList.toggle('on', on); b.style.color = on ? 'rgb(190,67,128)' : '';
    });
  }
  function renderWishlistPage() {
    var root = document.getElementById('wishlistRoot');
    if (!root) return;
    var ids = getWish().filter(function (h) { return P[h]; });
    if (!ids.length) return; /* keep the server-rendered empty state */
    root.innerHTML =
      '<div class="cart-head"><h1>Your wishlist</h1><p>' + ids.length + ' saved item' + (ids.length > 1 ? 's' : '') + ' — ready when you are.</p></div>' +
      '<div class="grid-products">' + ids.map(cardHTML).join('') + '</div>';
    markWishHearts();
  }

  /* ---------- app-like bottom tab bar (mobile only via CSS) ---------- */
  function injectBottomNav() {
    if (document.querySelector('.tabbar')) return;
    var ICON = {
      home: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M4 11l8-6 8 6M6 10v9h12v-9"/></svg>',
      shop: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="4" y="4" width="7" height="7" rx="1.5"/><rect x="13" y="4" width="7" height="7" rx="1.5"/><rect x="4" y="13" width="7" height="7" rx="1.5"/><rect x="13" y="13" width="7" height="7" rx="1.5"/></svg>',
      search: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>',
      heart: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M12 21s-7-4.6-9.3-9C1 8.5 2.9 5 6.3 5c2 0 3.2 1.2 3.7 2 .5-.8 1.7-2 3.7-2 3.4 0 5.3 3.5 3.6 7-2.3 4.4-9 9-9 9Z"/></svg>',
      bag: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M6 8h12l-1 12H7L6 8Z"/><path d="M9 8a3 3 0 0 1 6 0"/></svg>'
    };
    var t = (document.body.className.match(/template-(\w+)/) || [])[1] || '';
    function on(v) { return v ? ' active' : ''; }
    var nav = document.createElement('nav');
    nav.className = 'tabbar'; nav.setAttribute('aria-label', 'Primary');
    nav.innerHTML =
      '<a class="tab' + on(t === 'index') + '" href="/">' + ICON.home + '<span class="tab-lbl">Home</span></a>' +
      '<a class="tab" href="/#shop">' + ICON.shop + '<span class="tab-lbl">Shop</span></a>' +
      '<button class="tab" type="button" aria-label="Search">' + ICON.search + '<span class="tab-lbl">Search</span></button>' +
      '<a class="tab' + on(t === 'page') + '" href="/pages/wishlist">' + ICON.heart + '<span class="wish-count" style="display:none">0</span><span class="tab-lbl">Saved</span></a>' +
      '<a class="tab' + on(t === 'cart') + '" href="/cart">' + ICON.bag + '<span class="cart-count" style="display:none">0</span><span class="tab-lbl">Bag</span></a>';
    document.body.appendChild(nav);
  }

  /* ---------- search overlay (client-side over the catalog) ---------- */
  function buildSearch() {
    if (document.getElementById('searchOverlay')) return;
    var ov = document.createElement('div');
    ov.id = 'searchOverlay'; ov.className = 'search-overlay';
    ov.innerHTML =
      '<div class="search-scrim" data-search-close></div>' +
      '<div class="search-panel">' +
        '<div class="search-bar">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>' +
          '<input id="searchInput" type="search" placeholder="Search plushies, bottles, characters…" aria-label="Search products" autocomplete="off">' +
          '<button class="search-close" data-search-close aria-label="Close search"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M6 6l12 12M18 6 6 18"/></svg></button>' +
        '</div>' +
        '<div class="search-results" id="searchResults"></div>' +
      '</div>';
    document.body.appendChild(ov);
    var input = ov.querySelector('#searchInput');
    input.addEventListener('input', function () { runSearch(input.value); });
    runSearch('');
  }
  function openSearch() { buildSearch(); document.getElementById('searchOverlay').classList.add('open'); document.body.style.overflow = 'hidden'; setTimeout(function () { var i = document.getElementById('searchInput'); if (i) i.focus(); }, 40); }
  function closeSearch() { var ov = document.getElementById('searchOverlay'); if (ov) ov.classList.remove('open'); document.body.style.overflow = ''; }
  function runSearch(q) {
    var res = document.getElementById('searchResults'); if (!res) return;
    var all = Object.keys(P);
    q = (q || '').trim().toLowerCase();
    if (!q) { res.innerHTML = '<p class="search-hint">Search ' + all.length + ' products by name or category.</p>'; return; }
    var ids = all.filter(function (h) {
      var p = P[h];
      return (p.t + ' ' + p.c).toLowerCase().indexOf(q) >= 0;
    });
    res.innerHTML = ids.length
      ? '<p class="search-hint">' + ids.length + ' result' + (ids.length > 1 ? 's' : '') + '</p><div class="grid-products">' + ids.map(cardHTML).join('') + '</div>'
      : '<p class="search-empty">No matches — try another term.</p>';
    markWishHearts();
  }

  /* ---------- PDP variant state ---------- */
  var pdp = document.getElementById('pdp');
  if (pdp) {
    var variants = [];
    try { variants = JSON.parse(document.querySelector('[data-pdp-variants]').textContent); } catch (e) {}
    var img0 = (pdp.querySelector('.gallery-main img') || {}).src;

    function selectedOptions() {
      return Array.prototype.map.call(pdp.querySelectorAll('[data-optgroup]'), function (g) {
        var a = g.querySelector('[data-opt].active'); return a ? a.getAttribute('data-opt') : null;
      });
    }
    function matchVariant() {
      var sel = selectedOptions();
      return variants.filter(function (v) {
        return v.options.every(function (o, i) { return sel[i] == null || String(o) === String(sel[i]); });
      })[0];
    }
    function refreshPdp() {
      var v = matchVariant();
      var addBtns = pdp.querySelectorAll('[data-pdp-add]');
      var priceEl = pdp.querySelector('.pdp-price .now');
      var available = v && v.available;
      if (v) { pdp.setAttribute('data-variant-id', v.id); }
      if (priceEl && v) priceEl.textContent = v.price;
      addBtns.forEach(function (b) {
        b.disabled = !available;
        if (b.hasAttribute('data-buynow')) { b.textContent = available ? 'Buy it now' : 'Sold out'; }
        else { b.textContent = available ? 'Add to bag · ' + v.price : (v ? 'Sold out' : 'Unavailable'); }
      });
      /* mobile sticky buy-bar sync */
      var bp = document.querySelector('.pdp-buybar .buybar-price'); if (bp && v) bp.textContent = v.price;
      var ba = document.querySelector('.pdp-buybar [data-pdp-add]'); if (ba) { ba.disabled = !available; ba.textContent = available ? 'Add · ' + v.price : 'Sold out'; }
      /* image swap to the variant image */
      var main = pdp.querySelector('.gallery-main img');
      if (main) {
        main.src = (v && v.image) ? v.image : img0;
        pdp.querySelectorAll('.gallery-thumbs [data-thumb]').forEach(function (t) {
          t.classList.toggle('active', t.getAttribute('data-thumb') === main.getAttribute('src'));
        });
      }
    }

    /* sticky mobile buy bar */
    (function buildBuyBar() {
      var cur = matchVariant() || variants[0] || {};
      var img = (pdp.querySelector('.gallery-main img') || {}).src || '';
      var name = (pdp.querySelector('.pdp-info h1') || {}).textContent || '';
      var price = cur.price || (pdp.querySelector('.pdp-price .now') || {}).textContent || '';
      var bar = document.createElement('div');
      bar.className = 'pdp-buybar';
      bar.innerHTML =
        '<div class="buybar-media"><img src="' + esc(img) + '" alt=""></div>' +
        '<div class="buybar-txt"><div class="buybar-name">' + esc(name) + '</div>' +
        '<div class="buybar-price">' + esc(price) + '</div></div>' +
        '<button class="btn btn-primary" data-pdp-add>Add · ' + esc(price) + '</button>';
      document.body.appendChild(bar);
      var buyRow = pdp.querySelector('.buy-row');
      if (!buyRow) return;
      function syncBar() { bar.classList.toggle('show', buyRow.getBoundingClientRect().bottom < 8); }
      window.addEventListener('scroll', syncBar, { passive: true });
      window.addEventListener('resize', syncBar, { passive: true });
      syncBar();
    })();

    pdp._refresh = refreshPdp;
  }

  /* ---------- delegated interactions ---------- */
  document.addEventListener('click', function (e) {
    /* quick-add from a card (single-variant) */
    var qa = e.target.closest('[data-add-variant]');
    if (qa) { e.preventDefault(); addToCart(qa.getAttribute('data-add-variant'), 1, false); return; }

    /* PDP add / buy now */
    var addEl = e.target.closest('[data-pdp-add]');
    if (addEl) {
      e.preventDefault();
      if (addEl.disabled) return;
      var qtyEl = pdp && pdp.querySelector('.qty span');
      var qty = qtyEl ? (parseInt(qtyEl.textContent, 10) || 1) : 1;
      var vid = pdp ? pdp.getAttribute('data-variant-id') : null;
      addToCart(vid, qty, addEl.hasAttribute('data-buynow'));
      return;
    }

    /* search open / close */
    if (e.target.closest('[aria-label="Search"]')) { e.preventDefault(); openSearch(); return; }
    if (e.target.closest('[data-search-close]')) { closeSearch(); return; }

    /* wishlist toggle */
    var wish = e.target.closest('.wish[data-wish-id]');
    if (wish) {
      e.preventDefault();
      var wid = wish.getAttribute('data-wish-id');
      var on = toggleWish(wid);
      wish.classList.toggle('on', on); wish.style.color = on ? 'rgb(190,67,128)' : '';
      showToast(on ? ((P[wid] ? P[wid].t : 'Item') + ' saved to your wishlist ♡') : 'Removed from wishlist');
      if (document.getElementById('wishlistRoot')) renderWishlistPage();
      return;
    }

    /* promo code apply -> Shopify discount URL */
    var applyBtn = e.target.closest('[data-apply-promo]');
    if (applyBtn) {
      e.preventDefault();
      var inp = document.getElementById('promoCodeInput');
      var code = inp ? inp.value.trim() : '';
      if (code) window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(CFG.routes.cart);
      return;
    }

    /* cart line controls */
    var inc = e.target.closest('[data-line-inc]');
    if (inc) { var r1 = inc.closest('.cart-row'); var q1 = parseInt(r1.querySelector('.qty span').textContent, 10) || 1; changeLine(inc.getAttribute('data-line-inc'), q1 + 1); return; }
    var dec = e.target.closest('[data-line-dec]');
    if (dec) { var r2 = dec.closest('.cart-row'); var q2 = parseInt(r2.querySelector('.qty span').textContent, 10) || 1; changeLine(dec.getAttribute('data-line-dec'), Math.max(0, q2 - 1)); return; }
    var rem = e.target.closest('[data-line-remove]');
    if (rem) { changeLine(rem.getAttribute('data-line-remove'), 0); return; }

    /* PDP qty stepper */
    var qbtn = e.target.closest('.qty button');
    if (qbtn && qbtn.dataset.step) { var v = qbtn.parentElement.querySelector('span'); v.textContent = Math.max(1, parseInt(v.textContent, 10) + (qbtn.dataset.step === 'up' ? 1 : -1)); return; }

    /* gallery thumbnail */
    var thumb = e.target.closest('[data-thumb]');
    if (thumb && pdp) {
      var mainImg = pdp.querySelector('.gallery-main img');
      if (mainImg) mainImg.src = thumb.getAttribute('data-thumb');
      pdp.querySelectorAll('.gallery-thumbs [data-thumb]').forEach(function (t) { t.classList.toggle('active', t === thumb); });
      return;
    }

    /* PDP option button */
    var opt = e.target.closest('[data-opt]');
    if (opt) {
      var g = opt.closest('[data-optgroup]');
      if (g) {
        g.querySelectorAll('[data-opt]').forEach(function (x) { x.classList.remove('active'); });
        opt.classList.add('active');
        var block = opt.closest('.opt-block');
        var cur = block && block.querySelector('.opt-current'); if (cur) cur.textContent = opt.getAttribute('data-opt');
        if (pdp && pdp._refresh) pdp._refresh();
      }
      return;
    }
  });

  /* ---------- mobile drawer ---------- */
  var drawer = document.getElementById('drawer');
  var openBtn = document.getElementById('menuOpen');
  if (openBtn) openBtn.addEventListener('click', function () { drawer.classList.add('open'); });
  document.querySelectorAll('[data-drawer-close]').forEach(function (el) { el.addEventListener('click', function () { if (drawer) drawer.classList.remove('open'); }); });

  /* ---------- HOMEPAGE grid + filters + sort (from catalog) ---------- */
  var CAT_ORDER = ['Plushies', 'Drinkware', 'Bags & Backpacks', 'Home & Living', 'Jewelry',
    'Crochet Bouquets', 'Slippers', 'Beauty', 'Toys & Squishies', 'Pet', 'Accessories'];
  var grid = document.getElementById('shopGrid');
  if (grid) {
    var ids = Object.keys(P);
    var counts = {};
    ids.forEach(function (h) { var c = P[h].c; counts[c] = (counts[c] || 0) + 1; });
    var cats = CAT_ORDER.filter(function (c) { return counts[c]; })
      .concat(Object.keys(counts).filter(function (c) { return CAT_ORDER.indexOf(c) < 0; }).sort());

    var filtersEl = document.getElementById('filters');
    if (filtersEl) {
      filtersEl.innerHTML =
        '<button class="filter active" data-filter="All">All <span class="n">' + ids.length + '</span></button>' +
        cats.map(function (c) { return '<button class="filter" data-filter="' + esc(c) + '">' + esc(c) + ' <span class="n">' + counts[c] + '</span></button>'; }).join('');
    }

    var currentCat = 'All', currentSort = 'featured';
    function sortedIds() {
      var a = ids.slice();
      if (currentSort === 'price-asc') a.sort(function (x, y) { return P[x].pmin - P[y].pmin; });
      else if (currentSort === 'price-desc') a.sort(function (x, y) { return P[y].pmin - P[x].pmin; });
      return a;
    }
    var filterBtns = filtersEl ? filtersEl.querySelectorAll('.filter') : [];
    var emptyMsg = document.getElementById('shopEmpty');
    function applyFilter(cat) {
      currentCat = cat; var shown = 0;
      grid.querySelectorAll('.card').forEach(function (card) {
        var match = cat === 'All' || card.getAttribute('data-category') === cat;
        card.classList.toggle('hide', !match); if (match) shown++;
      });
      filterBtns.forEach(function (b) { b.classList.toggle('active', b.getAttribute('data-filter') === cat); });
      if (emptyMsg) emptyMsg.style.display = shown ? 'none' : 'block';
    }
    function renderGrid() { grid.innerHTML = sortedIds().map(cardHTML).join(''); markWishHearts(); applyFilter(currentCat); }

    var sortWrap = document.getElementById('sortWrap');
    if (sortWrap) {
      sortWrap.innerHTML = '<label class="sort"><span>Sort</span>' +
        '<select id="sortSelect" aria-label="Sort products">' +
          '<option value="featured">Featured</option>' +
          '<option value="price-asc">Price: low to high</option>' +
          '<option value="price-desc">Price: high to low</option>' +
        '</select></label>';
      sortWrap.querySelector('#sortSelect').addEventListener('change', function () { currentSort = this.value; renderGrid(); });
    }

    renderGrid();
    filterBtns.forEach(function (b) { b.addEventListener('click', function () { applyFilter(b.getAttribute('data-filter')); }); });
  }

  /* ---------- seamless marquee ---------- */
  function initMarquee() {
    var track = document.querySelector('.marquee-track'); if (!track) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var groups = track.querySelectorAll('.marquee-group');
    var unit = groups[0]; if (!unit) return;
    for (var i = groups.length - 1; i >= 1; i--) groups[i].remove();
    if (track._anim) { track._anim.cancel(); track._anim = null; }
    track.style.animation = 'none';
    if (reduce) return;
    var unitW = unit.getBoundingClientRect().width;
    var containerW = track.parentElement.getBoundingClientRect().width;
    if (!unitW) return;
    var need = Math.ceil((containerW + unitW) / unitW) + 1;
    for (var j = 1; j < need; j++) track.appendChild(unit.cloneNode(true));
    track._anim = track.animate(
      [{ transform: 'translateX(0)' }, { transform: 'translateX(-' + unitW + 'px)' }],
      { duration: (unitW / 70) * 1000, iterations: Infinity, easing: 'linear' }
    );
  }

  /* ---------- init ---------- */
  injectBottomNav();
  updateCartCount();
  renderWishCount();
  renderWishlistPage();
  markWishHearts();
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSearch(); });
  if (document.readyState === 'complete') initMarquee();
  else window.addEventListener('load', initMarquee);
  var rz; window.addEventListener('resize', function () { clearTimeout(rz); rz = setTimeout(initMarquee, 200); });
})();
